/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_1eaa1918"]'><div><div :class='["picker-demo-title"]'>Config day options:</div><cube-time-picker :day="(day)"/></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_1eaa1918"}'>
.picker-demo-title
  margin-bottom 8px
.event-params,
.demo-data
  margin-top: 10px
  .key
    margin-bottom: 10px
  .value
    margin-bottom: 20px
    white-space: break-spaces
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_1eaa1918"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_1eaa1918"}
  /** script content **/
  require("./config-day-picker.mpx.js?isComponent&outputPath=components%2Fconfig-day-picker1eaa1918%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./config-day-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fconfig-day-picker1eaa1918%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_1eaa1918"],
    ctorType: "component",
    outputPath: "components/config-day-picker1eaa1918/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-time-picker':getComponent(require("../../../packages/mpx-cube-ui/src/components/time-picker/index.mpx?isComponent&outputPath=components%2Findex057b2bbb%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>